import { FC } from 'react';

import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 20px 24px;
  font-weight: 700;
  font-size: 14px;
  color: #2e3035;
  background: #eff7ff;
  border-radius: 6px;
  .head {
    display: flex;
    .title {
      flex: 1;
      @media (min-width: 992px) {
        font-size: 16px;
      }
      .badge {
        display: inline-flex;
        align-items: center;
        margin-bottom: 12px;
        color: #055cf5;
        span:last-child {
          color: #2e3035;
        }
        .verifiedIcon {
          margin-right: 8px;
        }
      }
      p {
        font-weight: 500;
        @media (min-width: 992px) {
          font-size: 16px;
        }
      }
    }
  }
`;

const VerifiedPartner: FC = () => {
  return (
    <Wrapper>
      <div className="head">
        <div className="title">
          <span className="badge">
            <img className="verifiedIcon" src="/svg/smallVerifiedIcon.svg" />
            <span>미소 인증 파트너</span>
            <span>는</span>
          </span>
          <p>A/S를 100% 보장해요</p>
          <p>평점 4.5 이상을 유지해요</p>
          <p>당일에 추가금을 요구하지 않아요</p>
        </div>
      </div>
    </Wrapper>
  );
};

export default VerifiedPartner;
